import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

interface LoadingStateProps {
  message?: string;
  size?: 'small' | 'medium' | 'large';
  variant?: 'page' | 'section';
}

export const LoadingState: React.FC<LoadingStateProps> = ({ 
  message = 'Loading...', 
  size = 'medium',
  variant = 'page'
}) => {
  const sizeMap = {
    small: 24,
    medium: 40,
    large: 60
  };

  return (
    <Box 
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: variant === 'page' ? '60vh' : '200px'
      }}
    >
      <Box sx={{ textAlign: 'center' }}>
        <CircularProgress 
          size={sizeMap[size]} 
          sx={{ color: 'primary.main' }}
        />
        {message && (
          <Typography 
            variant="body1" 
            sx={{ 
              mt: 2,
              color: 'text.secondary'
            }}
          >
            {message}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default LoadingState; 